import React from 'react'
import Header from '../header'
import Footer from '../NewFooter'
import { useHistory } from 'react-router-dom'
import { makeStyles } from '@material-ui/styles'
import { toast, ToastContainer } from 'react-toastify'
import { Grid, Typography, Button, Paper, colors } from '@material-ui/core'
// import HeaderImage from '../../../images/Jobs/header_image.svg'
import HeaderImage from '../../../images/Jobs/header_image_1.webp'
import icon1 from '../../../images/Jobs/icon_1.svg'
import icon2 from '../../../images/Jobs/icon_2.svg'
import icon3 from '../../../images/Jobs/icon_3.svg'
import icon4 from '../../../images/Jobs/icon_4.svg'
import icon5 from '../../../images/Jobs/icon_5.svg'
import icon6 from '../../../images/Jobs/icon_6.svg'

const useStyles = makeStyles(theme => ({
   container: {
      //   padding: '2rem',
      maxWidth: 1140,
      marginLeft: 'auto',
      marginRight: 'auto',
      backgroundColor: '#fff',
      // height: '2300px'
      // height: '1300px',
      '@media (max-width: 1000px)': {
         height: 'unset'
      }
   },
   heroBox: {
      display: 'flex',
      alignItems: 'center',
      borderRadius: 20,
      padding: '2rem',
      backgroundColor: '#fff',
      boxShadow: '0 8px 30px rgba(0,0,0,0.05)',
      position: 'relative'
   },
   textBlock: {
      //   flex: 1,
      border: '1px solid #cccc',
      borderRadius: '16px',
      height: '270px',
      width: '500px',
      marginLeft: '20px',
      minWidth: '300px',
      maxWidth: '600px',
      backgroundColor: '#fff',
      position: 'absolute',
      padding: '20px 30px',
      '@media (max-width: 600px)': {
         width: '100%',
         position: 'unset'
      }
   },
   title: {
      color: '#5F4B95',
      fontWeight: 400,
      fontSize: '1.5rem',
      lineHeight: '35px'
   },
   headline: {
      fontSize: '2.5rem',
      marginBottom: '0.5rem',
      lineHeight: '35px',
      color: '#1A202C',
      fontWeight: '700'
   },
   subText: {
      marginBottom: '0.5rem',
      color: '#1A202C',
      lineHeight: '25px',
      fontWeight: '400',
      fontSize: '18px'
   },
   subText1: {
      marginBottom: '1rem',
      color: '#1A202C',
      lineHeight: '25px',
      fontWeight: '400',
      fontSize: '13px'
   },
   browseButton: {
      backgroundColor: '#5F4B95',
      color: '#fff',
      textTransform: 'none',
      fontWeight: 600,
      borderRadius: 8,
      padding: '4px 20px',
      '&:hover': {
         backgroundColor: '#4a148c'
      },
      lineHeight: '25px'
   },
   imageBox: {
      flex: 1,
      textAlign: 'right',
      '& img': {
         width: '672px'
      }
   },
   heroImage: {
      maxWidth: '100%',
      borderRadius: 20
   },
   cardHeadline: {
      fontSize: '24px',
      marginBottom: '1rem',
      lineHeight: '35px',
      textAlign: 'center',
      color: '#1A202C',
      fontWeight: '500',
      '& span': {
         color: '#5F4B95',
         fontWeight: '300'
      }
   },

   cardListbox: {
      display: 'flex',
      flexWrap: 'wrap',
      justifyContent: 'center',
      gap: '16px',
      marginBottom: '24px'
   },
   card: {
      // backgroundColor: '#f8fbfd',
      backgroundColor: '#F7FAFC',
      borderRadius: 16,
      // height: '210px',
      width: '328px',
      // padding: theme.spacing(3),
      boxShadow: '0 4px 12px rgba(0, 0, 0, 0.05)',
      textAlign: 'left',
      padding: '20px',
      '@media (max-width: 840px)': {
         position: 'unset',
         width: '48%'
      },
      '@media (max-width: 580px)': {
         width: '90%',
         margin:'auto',
      }
   },
   icon: {
      width: 60,
      height: 60,
      margin: '10px 0px 10px 0px'
   },
   cardTitle: {
      fontSize: '18px',
      fontWeight: 400,
      margin: '10px 0px 10px 0px',
      color: '#000',
      textAlign: 'left'
   },
   cardText: {
      fontSize: '14px',
      color: '#4f5b67',
      margin: '10px 0px 10px 0px',
      textAlign: 'left'
   }
}))

const FindJobsPanel = () => {
   const classes = useStyles()
   const domHistory = useHistory()
   const handleOnBrowseJob = () => {
      domHistory.push('/jobs/browse')
   }

   return (
      <>
         <Header />
         <ToastContainer position="top-right" autoClose={2500} closeOnClick />
         <div className={classes.container}>
            <div className={classes.heroBox}>
               <div className={classes.textBlock}>
                  <Typography className={classes.title}>Get Shifts</Typography>
                  <Typography className={classes.headline}>Recruitment</Typography>
                  <Typography className={classes.subText}>Your Gateway to Flexible Work Opportunities</Typography>
                  <Typography className={classes.subText1}>Find shifts that fit your lifestyle and schedule with ease</Typography>
                  <Button className={classes.browseButton} onClick={handleOnBrowseJob}>
                     Browse Job Openings
                  </Button>
               </div>
               <div className={classes.imageBox}>
                  <img src={HeaderImage} alt="employee" loading="lazy" />
               </div>
            </div>
            <div className={classes.cardContainer}>
               <Typography className={classes.cardHeadline}>
                  Why Work with <span>Get Shifts?</span>
               </Typography>
               <div className={classes.cardListbox}>
                  <div className={classes.card}>
                     <img src={icon1} alt="icon" loading="lazy" className={classes.icon} />
                     <Typography className={classes.cardTitle}>
                        Choose Your <br /> Contract Type
                     </Typography>
                     <Typography className={classes.cardText}>Opt for long-term, short-term or temp-to-perm roles</Typography>
                  </div>

                  <div className={classes.card}>
                     <img src={icon2} alt="icon" loading="lazy" className={classes.icon} />
                     <Typography className={classes.cardTitle}>
                        Choose Your <br /> Own Schedule
                     </Typography>
                     <Typography className={classes.cardText}>Work around your lifestyle at the time that suits you best</Typography>
                  </div>

                  <div className={classes.card}>
                     <img src={icon3} alt="icon" loading="lazy" className={classes.icon} />
                     <Typography className={classes.cardTitle}>
                        Choose Work <br /> in an Instant
                     </Typography>
                     <Typography className={classes.cardText}>Work around your lifestyle at the time that suits you best</Typography>
                  </div>

                  <div className={classes.card}>
                     <img src={icon4} alt="icon" loading="lazy" className={classes.icon} />
                     <Typography className={classes.cardTitle}>
                        Choose when <br /> you get Paid
                     </Typography>
                     <Typography className={classes.cardText}>Choose whether to get paid the same day or the following week</Typography>
                  </div>

                  <div className={classes.card}>
                     <img src={icon5} alt="icon" loading="lazy" className={classes.icon} />
                     <Typography className={classes.cardTitle}>
                        Choose your <br /> Work Location
                     </Typography>
                     <Typography className={classes.cardText}>Work around your lifestyle at the time that suits you best</Typography>
                  </div>

                  <div className={classes.card}>
                     <img src={icon6} alt="icon" loading="lazy" className={classes.icon} />
                     <Typography className={classes.cardTitle}>
                        Choose who <br />
                        you work fort
                     </Typography>
                     <Typography className={classes.cardText}>Select from a growing range of market-leading brands</Typography>
                  </div>
               </div>
            </div>
         </div>
         <Footer />
      </>
   )
}

export default FindJobsPanel
